import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { StudentService } from '../../../shared-components/student/student.service';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { LunchMealChoice, MonthlyLunchMenuChoices } from '../meal-service.model';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { LoginService } from '../../../shared-modules/login/login.service';
import { LoginSettings } from '../../../shared-modules/login/LoginSetting.model';
@Component({
  selector: 'monthly-lunch-menu',
  templateUrl: './monthly-lunch-menu.component.html'
})
export class MonthlyLunchMenuComponent implements OnInit {

  @Input() lunchMealChoice: LunchMealChoice[];
  @Input() currentDate: Date;
  angularMatDataMonthlyLunchMenu = new TylerMatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;

  selectedChoice: MonthlyLunchMenuChoices[] = [];
  studentMonthlyLunchMenuChoice: LunchMealChoice[] = [];
  columnsToDisplayLunchMenu = [];
  showMontlyLunchMenuGrid: boolean;
  LoginSettings: LoginSettings;

  constructor(
    private studentService: StudentService,
    private datePipe: DatePipe,
    private loginService: LoginService
  ) {
    this.LoginSettings = this.loginService.LoginSettings;
    if (this.lunchMealChoice) {
      this.angularMatDataMonthlyLunchMenu = new TylerMatTableDataSource(this.lunchMealChoice);
    }
  }

  ngOnInit() {
    if (this.lunchMealChoice != null && this.lunchMealChoice.length > 0) {
      this.angularMatDataMonthlyLunchMenu.data = this.lunchMealChoice;
      this.getMonthlyLunchMenuHeader();
      this.getMonthlyLunchMenuData();
    }
    setTimeout(() => {
      this.angularMatDataMonthlyLunchMenu.sort = this.sort;
    }, 0);
  }

  refreshGrid(lunchMealChoice: LunchMealChoice[], currentDate: Date) {
    if (lunchMealChoice.length > 0) {
      this.currentDate = currentDate;
      this.lunchMealChoice = lunchMealChoice;
      this.getMonthlyLunchMenuHeader();
      this.getMonthlyLunchMenuData();
      setTimeout(() => {
        this.angularMatDataMonthlyLunchMenu.sort = this.sort;
      }, 0);
    }
  }

  getMonthlyLunchMenuHeader() {
    const selectedLunchMealChoice: LunchMealChoice = this.lunchMealChoice.filter(function (o) { return o.Id == 1; })[0];
    this.selectedChoice = selectedLunchMealChoice.MonthlyLunchMenuChoices;
    this.columnsToDisplayLunchMenu = ['Date'];
    if (this.selectedChoice.length > 0) {
      this.selectedChoice.forEach(selectedChoice => {
        this.columnsToDisplayLunchMenu.push(selectedChoice.Choice);
      });
    }
  }

  getMonthlyLunchMenuData() {
    const startDate: Date = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
    const endDate: Date = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
    this.studentMonthlyLunchMenuChoice = [];

    this.lunchMealChoice.forEach(obj => {
      if (new Date(obj.Date) >= new Date(startDate) && new Date(obj.Date) <= new Date(endDate)) {
        this.studentMonthlyLunchMenuChoice.push(obj);
      }
    });

    this.showMontlyLunchMenuGrid = false;
    this.studentMonthlyLunchMenuChoice.forEach(obj => {
      if (obj != null && obj.MonthlyLunchMenuChoices != null) {
        for (let j = 0; j < obj.MonthlyLunchMenuChoices.length; j++) {
          if (obj.MonthlyLunchMenuChoices[j] != null && obj.MonthlyLunchMenuChoices[j].ChoiceDescription != null) {
            this.showMontlyLunchMenuGrid = true;
            break;
          }
        }
      }
    });

    this.angularMatDataMonthlyLunchMenu.data = this.studentMonthlyLunchMenuChoice;
  }

  getMonthlyLunchMenuAriaRow(row: LunchMealChoice): string {
    const colList: string[] = ['Day', 'Date'];
    if (this.selectedChoice.length > 0) {
      this.selectedChoice.forEach(selectedChoice => {
        colList.push(selectedChoice.Choice);
      });
    }

    const dataList: string[] = [this.datePipe.transform(row.Date, 'EEE'), this.datePipe.transform(row.Date, 'MM/dd/yy')];
    if (row.MonthlyLunchMenuChoices.length > 0) {
      row.MonthlyLunchMenuChoices.forEach(lunchMenuChoices => {
        colList.push(lunchMenuChoices.ChoiceDescription);
      });
    }
    return AriaDirective.concatAriaStrings(colList, dataList);
  }

  getMonthlyLunchMenuRecords() {
    // dynamic header binding
    this.getMonthlyLunchMenuHeader();
    // dynamic Data binding
    this.getMonthlyLunchMenuData();
  }

    getChoiceNumber(choice: any) {
      if (choice) {
          return choice.replace('Choice ', '');
      }
    }
}
